import { useTranslation } from 'react-i18next';

import { Box } from '@sternum/styled-system';
import { Link, Text12M, Text12SB } from '@sternum/ui';
import { SternumLogo } from '@sternum/web/components';
import { Colors } from '@sternum/web/components/theme/constants';
import { Config } from '@sternum/web/config';
import { namespaces } from '@sternum/web/services/i18n';

import { Container } from './MarketingBlock.styles';

export function MarketingBlockForTrial() {
  const { t } = useTranslation(namespaces.appContainerWithMenu);

  return (
    <Container aria-label="marketing block trial">
      <Box textAlign="center">
        <SternumLogo textColor={Colors.White} />
      </Box>

      <Box textAlign="center">
        <Box>
          <Text12M color={Colors.GreyLighter}>{t('marketingBlock.upgradeLicenceAndContactUs')}</Text12M>
        </Box>
        <Box>
          <Link href={`mailto:${Config.app.serviceEmail}`} color={Colors.GreyLightest}>
            <Text12SB color={Colors.GreyLightest}>{Config.app.serviceEmail}</Text12SB>
          </Link>
        </Box>
      </Box>
    </Container>
  );
}
